import { render, staticRenderFns } from "./related_company_add.vue?vue&type=template&id=6805ad96&"
import script from "./related_company_add.vue?vue&type=script&lang=js&"
export * from "./related_company_add.vue?vue&type=script&lang=js&"
import style0 from "./related_company_add.vue?vue&type=style&index=0&id=6805ad96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports